import React from 'react';

const Forbidden: React.FunctionComponent = () => <h2>403 - Forbidden</h2>;

export default Forbidden;
